﻿import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { ISubscription } from "rxjs/Subscription";
import { Observable } from 'rxjs/Observable';
import "rxjs/add/observable/interval";

import { AuthService } from '../auth/auth.service';
import { GlobalService } from '../services/global.service';

@Component({
  selector: 'app-resetpassword',
  templateUrl: './resetpassword.component.html',
  styleUrls: ['./resetpassword.component.css']
})
export class ResetPasswordComponent implements OnInit, OnDestroy {
  model: any = {};
  loading = false;
  returnUrl: string;
  error: string;
  userName: string;
  //BASE_REG_ENDPOINT = "http://api.hvsfinancial.com.loc/api/CoreRegistration/";

  @Input() controls: FormControl;
  myForm: FormGroup;
  mediumRegex = new RegExp("^(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$");
  message: string;
  private subscription: ISubscription;

  public waitingOnData: boolean = false;

  public sitePath: string = '';
  public isHVAM: boolean;

  constructor(private fb: FormBuilder, private route: ActivatedRoute, private router: Router, private authService: AuthService, public Global: GlobalService) {
    this.sitePath = window.location.hostname;
    this.sitePath = this.sitePath.substring(0, this.sitePath.indexOf('.'));
   
    this.isHVAM = (this.sitePath == 'hvam' || this.sitePath == 'hwh') ? true : false;
   }

  ngAfterViewInit() {
    if(this.isHVAM){

      console.log('should not be here');
      let head = document.getElementsByTagName('head')[0];
      let style = document.createElement('link');
      style.rel = 'stylesheet';
      style.href = 'assets/css/hvam/hvam-styling.css';
      head.appendChild(style);
      console.log('style', head);

    }
  }

  ngOnInit() {
    var query = this.router.url.split("/resetPassword/");
    this.myForm = this.fb.group({
      NewPassword: ['', [Validators.required, Validators.pattern(this.mediumRegex), Validators.minLength(8)]],
      ConfirmPassword: ['', Validators.required],
      UserCode: [query[1]]
    });

    this.userName = query[1].substring(query[1].lastIndexOf("%") + 1).replace('3D', '');
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  onSubmit(form: FormGroup) {

    // var body = "{";
    // body += '"Username":"' + form.value.UserCode + '",';
    // body += '"Password":"' + form.value.NewPassword + '"';
    // body += "}";

    const body = { Username: form.value.UserCode, Password: form.value.NewPassword };

    this.Global.post("CoreRegistration/ResetPassword", JSON.stringify(body))
      .subscribe(response => {
        if (response) {
          if (response.indexOf('This Reset Password link either') > -1)
            this.message = response;
          else {
            this.message = "Your password has been reset. You will now be transfered to the login page in 5 seconds.";

            this.subscription = Observable.interval(5000)
              .subscribe((val) => {
                this.router.navigate(['/login']);
              });
          }
        } else if (!response) {
          this.message = "There seemed to be an issue; For security reasons, we did not proceed with the password reset.";
        } else {
          this.message = response; //message from server
        }
      });
  }
}
